import React from 'react';
import './payment-information.css';
import Modal from "react-bootstrap/Modal";
import SummaryCharges from "../summary-charges/summary-charges";
import Button from "react-bootstrap/Button";
import NumberFormat from "react-number-format";
import ReactHtmlParser from "react-html-parser";
import CreditCard from "../credit-card/credit-card";

class PaymentInformation extends React.Component {

    constructor(props) {
        super(props);
        this.booking = this.props.booking;
        this.paymentInformation = React.createRef();
        this.submitPaymentButton = null;
        this.requireCvv = this.booking.requireCvv === false ? this.booking.requireCvv : true;

        this.state = {
            focused: '',
            paymentInProcess: false,
            confirmPaymentButtonText: 'Processing',
            cancelPaymentButtonDisabled: false,
            showTermsAndConditionsPopup: false,
            termsAndConditionsAccepted: this.booking.termsAndConditionsAccepted,
            showConfirmationPopup: false,
            creditCardNumber: '',
            nameOnCard: '',
            expiry: '',
            expireMonth: 'MM',
            expireYear: 'YYYY',
            cvc: '',
            cvcRequiredLength: [3],
            name: '',
            address1: '',
            address2: '',
            city: '',
            state: '',
            zipCode: '',
            showCreditCardPopup: false,
            otherAmountToPay: '0.00',
            remainingAmountToPay: '0.00',
            includeInsurance: null, //this.booking.remainingBalanceIncludingInsurance != this.booking.remainingBalanceExcludingInsurance,
            payRemainingBalance: true,
            payOtherAmount: false,
            payNextPaymentDue: false,
            showCreditCardDeclinedErrorMessage: false,
            charges: {
                totalWithOutInsurance: this.booking.totalWithOutInsurance,
                insuranceTotal: this.booking.insuranceTotal,
                paymentsReceived: this.booking.paymentsReceived,
                pendingPaymentTotal: this.booking.pendingPaymentTotal,
                remainingBalanceIncludingInsurance: this.booking.remainingBalanceIncludingInsurance,
                remainingBalanceExcludingInsurance: this.booking.remainingBalanceExcludingInsurance,
                //nextPaymentDueDate: this.booking.nextPaymentDueDate,
                finalPaymentDate: this.booking.finalPaymentDate,
                includeInsurance: this.booking.remainingBalanceIncludingInsurance !== this.booking.remainingBalanceExcludingInsurance,
                currentAmount: 0
            },
            isCreditCardValid: false,
            isCreditCardAllowed: true,
            errors: new Map(),
            statesList: '',
            validationOnServerSideIsDone: true,
            requireCvv: this.requireCvv
        }
        this.creditCardInfoSection = React.createRef();

        this.populateBillingSection(0);

        this.htmlElementFocused = false;

    }

    DEFAULT_MIN_AMOUNT_DUE = 25;

    getErrorList = () => {
        let errors = [];
        this.state.errors.forEach((value, index) => {
            errors.push(
                <div className="rea-block-12 rea-errorMessage">
                    <a className="rea-link" data-link_to={value.input} onClick={e=>{e.preventDefault();this.navigate()}} href="# ">{value.message}</a>
                </div>);
        });
        return errors;
    }

    navigate = event => {
        const link_to = event.currentTarget.dataset.link_to;
        document.getElementById(link_to) && document.getElementById(link_to).focus();
    }

    componentWillMount = () => {

        this.cardHolders = [];
        for (let i = 0; i < this.booking.guests.length; i++) {
            if (i === 0) {
                this.cardHolders.push(<option
                    value={i} selected>{this.booking.guests[i].firstName} {this.booking.guests[i].lastName}</option>);
            } else {
                this.cardHolders.push(<option
                    value={i}>{this.booking.guests[i].firstName} {this.booking.guests[i].lastName}</option>);
            }
        }

        if (this.booking.bookingEmailContact !== null && this.booking.bookingEmailContact !== undefined) {
            this.cardHolders.push(<option
                value={this.booking.guests.length}>{this.booking.bookingEmailContact.firstName} {this.booking.bookingEmailContact.lastName}</option>);
        }

        this.populateBillingSection(0);

        let statesList = [];
        fetch('/wthrest/customer-self-service/getStates.rs').then(response => response.json()).then(jsonResponse => {
            let states = [];
            if (jsonResponse) {
                states = jsonResponse.states;
            }
            for (let i = 0; i < states.length; i++) {
                statesList.push(<option
                    value={states[i].code}>{states[i].name}</option>);
            }
            this.setState({statesList: statesList});
        });
    }

    render = () => {
        let years = [];
        let currentYear = new Date().getFullYear();
        years.push(<option value='YYYY'>YYYY</option>);
        for (let i = 0; i < 10; i++) {
            years.push(<option value={currentYear + i}>{currentYear + i}</option>);
        }

        return (
            <div className="payment-information" ref={this.paymentInformation}>
                {
                    this.state.paymentInProcess &&
                    <div className="rea-curtain">
                        <div className="rea-loadingElements rea-processingPayment">
                            <div className="rea-loadingMessage">
                                Processing Payment
                            </div>
                            <div className="rea-ldsEllipsis">
                                <div></div>
                                <div></div>
                                <div></div>
                                <div></div>
                            </div>
                            <div className="rea-loadingMessageSmall">
                                This process may take a few moments. Please do not refresh the page, click the browser
                                back button or close this window.
                            </div>
                        </div>
                    </div>
                }
                {this.state.errors.size > 0 &&
                <div className="rea-block-row">
                    <div className="rea-block-12 wth2-errorMessage">
                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                        <div className="rea-block-12 wth2-errorMessageHeader">
                            Please complete the required fields.
                        </div>
                        {
                            this.getErrorList()
                        }
                    </div>
                </div>
                }
                <Modal show={this.state.showCreditCardPopup} onHide={this.closeCreditCardPopup}>
                    <Modal.Header closeButton>
                        <Modal.Title>How do I find my CVV number?</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="rea-block-row">
                            <div className="wth2-cvcPopUpContainer rea-block-6">
                                <h5 id="cc_cvcInfoHeader" className="wth2-simplePopupHeader">Visa, Mastercard,<br/>Discover
                                    (3 digits)</h5>
                                <p id="cc_cvcInfoContent" className="wth2-simplePopupContent wth2-popupDatesContent">
                                    <img src="/images_unique/css/Visa-MC-Disc.png" id="css_cvcPopUpImageVisa"
                                         className="wth2-css_cvcPopUpImage" alt="Credit card logos"/>

                                </p>
                            </div>
                            <div className="wth2-cvcPopUpContainer rea-block-6">
                                <h5 id="cc_cvcInfoHeader2" className="wth2-simplePopupHeader">American Express<br/>(4
                                    digits)</h5>
                                <p id="cc_cvcInfoContent2" className="wth2-simplePopupContent wth2-popupDatesContent">
                                    <img src="/images_unique/css/AmEx.png" id="css_cvcPopUpImageAmex"
                                         className="wth2-css_cvcPopUpImage" alt="Amercian Express Logo"/>
                                </p>
                            </div>
                        </div>
                    </Modal.Body>
                </Modal>

                <Modal show={this.state.showConfirmationPopup} onHide={this.cancelPayment}>
                    <Modal.Header closeButton>
                        <Modal.Title>Confirm Payment</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div class="rea-reviewSummary">
                            Please review your Summary of Charges and confirm today's payment below.
                        </div>
                        <div class="rea-confirmSumCharges">
                            <SummaryCharges charges={this.state.charges}/>
                        </div>
                        <div className="rea-confirmTodaysPay">
                            <div className="rea-todaysPayment">
                                <div className="rea-block-row">
                                    <div className="rea-block-12">
                                        <div class="rea-sectionHeaders">Today's Payment Information</div>
                                    </div>
                                    <div className="rea-block-12 rea-creditcardholder">
                                        <div className="rea-paymentInfoList rea-block-row">
                                            <div className="rea-paymentInformationContainer rea-block-12">
                                                <div className="rea-block-row">
                                                    <div className="rea-block-12">
                                                        <span><strong>Credit Card Holder:</strong></span>
                                                    </div>
                                                </div>
                                                <div className="rea-block-row">
                                                    <div className="rea-block-12">
                                                        <div class="rea-ccHolderInfo">{this.state.nameOnCard}</div>
                                                        <div
                                                            class="rea-ccHolderInfo">{this.state.address1 + ' ' + this.state.address2}</div>
                                                        <div
                                                            class="rea-ccHolderInfo">{this.state.city}, {this.state.state} - {this.state.zipCode}</div>
                                                    </div>
                                                </div>
                                                <div className="rea-block-row">
                                                    <div className="rea-block-12 rea-acceptTermsText">
                                                        <span><strong>Payment:</strong></span>
                                                    </div>
                                                </div>
                                                <div className="rea-block-row">
                                                    <div className="rea-block-12">
                                                        <span><NumberFormat value={this.getAmountToPay()}
                                                                            displayType={'text'}
                                                                            thousandSeparator={true} decimalScale='2'
                                                                            fixedDecimalScale='true'
                                                                            prefix={'$'}/> will be charged to your credit card ending in {this.state.creditCardNumber.substring(this.state.creditCardNumber.length - 4, this.state.creditCardNumber.length)} expiring on {this.state.expireMonth}/{this.state.expireYear}.</span>
                                                    </div>
                                                </div>
                                                <div className="rea-block-row">
                                                    <div className="rea-block-12 rea-acceptTermsText">
                                                        <span>By submitting this payment, I understand and accept all associated Terms and Conditions. I accept the restrictions and penalties of this fare. I also understand that cancellation fees may apply.</span>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={this.cancelPayment}
                                disabled={this.state.paymentInProcess}>
                            Cancel
                        </Button>
                        {
                            !this.state.paymentInProcess &&
                            <Button variant="primary" onClick={this.handleSubmit}>
                                Confirm <NumberFormat value={this.getAmountToPay()} displayType={'text'}
                                                      thousandSeparator={true} decimalScale='2'
                                                      fixedDecimalScale='true'
                                                      prefix={'$'}/> Payment
                            </Button>
                        }
                        {
                            this.state.paymentInProcess &&
                            <Button variant="primary" disabled={true}>
                                Processing Payment
                            </Button>
                        }
                    </Modal.Footer>
                </Modal>

                <Modal size="lg" show={this.state.showTermsAndConditionsPopup} onHide={this.cancelTermsAndConditions}>
                    <Modal.Header closeButton>
                        <Modal.Title>Terms And Conditions</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {ReactHtmlParser(this.booking.termsAndConditionsMarkup)}
                    </Modal.Body>
                    <Modal.Footer>
                        <div className="rea-block-12">
                            <a className="rea-printBtn rea-textLink" onClick={e=>{e.preventDefault();this.openPrintVersion()}} href="# "><i
                                className="fa fa-print"></i> Print</a>
                            <Button variant="secondary" className="rea-floatRight rea-btnMargin"
                                    onClick={this.cancelTermsAndConditions}
                                    disabled={this.state.acceptTermsAndConditionsButtonDisabled}>
                                Close
                            </Button>
                        </div>
                    </Modal.Footer>
                </Modal>
                <div className="rea-block-row">
                    <div className="rea-block-12 rea-padding-0">
                        <div class="rea-sectionHeaders">Payment Information</div>
                    </div>
                    <div className="rea-block-12 rea-paymentHeader rea-amountToPayHeader">
                        <div>Amount to Pay</div>
                    </div>
                    <div className="rea-block-12 rea-amountPay rea-mobile-padding-0">
                        <form onSubmit={this.handleSubmit} className="rea-amountPayForm">
                            {this.leisureCarePaymentNeeded() &&
                            <div className="rea-block-12 rea-padding-0 rea-includeLeisure">
                                <label className="rea-block-12 rea-padding-0">Are you including payment for LeisureCare
                                    Travel Insurance?</label>
                                <div className="form-check rea-block-1 rea-bold">
                                    <input className="form-check-input" type="radio" name="includeLeisureCare"
                                           id="includeLeisureCare"
                                           aria-labelledby="includeLeisureCareLabel"
                                           onChange={event => {
                                               this.setState({includeInsurance: true})
                                           }}>
                                    </input>
                                    <label className="form-check-label" id="includeLeisureCareLabel"
                                           htmlFor="includeLeisureCare">Yes</label>
                                </div>
                                <div className="form-check rea-block-1 rea-bold">
                                    <input className="form-check-input" type="radio"
                                           id="doNotIncludeLeisureCare"
                                           aria-labelledby="doNotIncludeLeisureCareLabel"
                                           name="includeLeisureCare"
                                           onChange={event => {
                                               this.setState({includeInsurance: false})
                                           }}>
                                    </input>
                                    <label className="form-check-label" id="doNotIncludeLeisureCareLabel"
                                           htmlFor="doNotIncludeLeisureCare">No</label>
                                </div>
                                {
                                    this.state.errors.get('includeLeisureCare') &&
                                    <div className="rea-block-12 rea-padding-0">
                                        <div
                                            className="rea-errorMessage">{this.state.errors.get('includeLeisureCare').message}</div>
                                    </div>
                                }
                            </div>
                            }
                            {this.booking.nextPaymentDueAmount > 0 &&
                            <div className="rea-block-12 form-check rea-amountPayRow rea-nextPayment">
                                <input className="form-check-input" type="radio" name="amountToPayOption"
                                       id="nextPaymentDueAmount"
                                       aria-labelledby="nextPaymentDueAmountLabel"
                                       onChange={event => {
                                           this.setState({payOtherAmount: !event.target.checked})
                                           this.setState({payRemainingBalance: !event.target.checked})
                                           this.setState({payNextPaymentDue: event.target.checked})
                                           this.setState({nextPaymentDueToPay: this.getNextAmountToPay()});
                                       }} defaultChecked={this.state.payNextPaymentDue}>
                                </input>
                                <label className="form-check-label" id="nextPaymentDueAmountLabel"
                                       htmlFor="nextPaymentDueAmount">Pay Next Payment
                                    Due:</label>
                                <div className="rea-remainingBalance">
                                    <span>&nbsp;<NumberFormat value={this.getNextAmountToPay()}
                                                              displayType={'text'}
                                                              thousandSeparator={true} decimalScale='2'
                                                              fixedDecimalScale='true'
                                                              prefix={'$'}/></span>
                                </div>
                                {
                                    this.leisureCarePaymentNeeded() && this.state.includeInsurance === true &&
                                    <label className="form-check-label rea-coverProtection"> (Includes LeisureCare
                                        Travel Insurance) </label>
                                }
                                {
                                    this.leisureCarePaymentNeeded() && (this.state.includeInsurance === null || this.state.includeInsurance === undefined || this.state.includeInsurance === false) &&
                                    <label className="form-check-label rea-coverProtection"> (Excludes LeisureCare
                                        Travel Insurance) </label>
                                }
                            </div>
                            }
                            <div className="form-check rea-block-12 rea-amountPayRow rea-remainingBal">
                                <input className="form-check-input" type="radio" name="amountToPayOption"
                                       id="payRemainingBalance"
                                       aria-labelledby="payRemainingBalanceLabel"
                                       onChange={event => {
                                           this.setState({payOtherAmount: !event.target.checked})
                                           this.setState({payRemainingBalance: event.target.checked})
                                           this.setState({payNextPaymentDue: !event.target.checked})
                                           this.setState({remainingAmountToPay: this.getRemainingBalanceToPay()});
                                       }} defaultChecked={this.state.payRemainingBalance}>
                                </input>
                                <label className="form-check-label" id="payRemainingBalanceLabel"
                                       htmlFor="payRemainingBalance">Remaining Balance:</label>
                                <div class="rea-remainingBalance">
                                    <span>&nbsp;<NumberFormat value={this.getRemainingBalanceToPay()}
                                                              displayType={'text'}
                                                              thousandSeparator={true} decimalScale='2'
                                                              fixedDecimalScale='true'
                                                              prefix={'$'}/></span>
                                </div>
                                {
                                    this.leisureCarePaymentNeeded() && this.state.includeInsurance === true &&
                                    <label className="form-check-label rea-coverProtection"> (Includes LeisureCare
                                        Travel Insurance) </label>
                                }
                                {
                                    this.leisureCarePaymentNeeded() && (this.state.includeInsurance === null || this.state.includeInsurance === undefined || this.state.includeInsurance === false) &&
                                    <label className="form-check-label rea-coverProtection"> (Excludes LeisureCare
                                        Travel Insurance) </label>
                                }
                            </div>
                            <div class="rea-block-12 rea-padding-0 rea-amountPayRow">
                                <div className="rea-otherAmountRadio">
                                    <div className="form-check">
                                        <input className="form-check-input" type="radio"
                                               name="amountToPayOption"
                                               id="payOtherAmountCheck" aria-labelledby="payOtherAmountLabel"
                                               onChange={event => {
                                                   this.setState({payOtherAmount: event.target.checked});
                                                   this.setState({payRemainingBalance: !event.target.checked});
                                                   this.setState({payNextPaymentDue: !event.target.checked})
                                                   document.getElementById("payOtherAmount").disabled = false;
                                                   document.getElementById("payOtherAmount").focus();
                                               }}>
                                        </input>
                                        <label className="form-check-label" id="payOtherAmountLabel"
                                               htmlFor="payOtherAmount">Pay Other Amount:
                                        </label>
                                    </div>
                                </div>
                                <div className="rea-otherAmount">
                                    <div className="rea-otherAmountIcon">$</div>
                                    <div className="rea-otherAmountInput">
                                        <input type="text" className="form-control" placeholder=""
                                               value={this.state.otherAmountToPay}
                                               id="payOtherAmount"
                                               aria-labelledby="payOtherAmountLabel"
                                               onChange={event => {
                                                   const re = /^\d+(\.\d{0,2})?$/
                                                   if (event.target.value === '' || re.test(event.target.value)) {
                                                       this.setState({otherAmountToPay: event.target.value})
                                                   }
                                               }}
                                               onFocus={this.selectInputValue}
                                               disabled={!this.state.payOtherAmount}
                                               aria-invalid={this.state.errors.get('amountToPay') !== undefined}></input>
                                    </div>
                                </div>
                                <div className="rea-coverProtection">
                                    (Payment must be <NumberFormat value={this.minimumPaymentDue()}
                                                                   displayType={'text'}
                                                                   thousandSeparator={true} decimalScale='2'
                                                                   fixedDecimalScale='true'
                                                                   prefix={'$'}/> or
                                    greater{this.leisureCarePaymentNeeded() && this.state.includeInsurance && ' to cover LeisureCare Travel Insurance'})
                                </div>
                            </div>
                            <div className="form-inline rea-block-12 rea-amount-error">
                                {
                                    this.state.errors.get('amountToPay') &&
                                    <div
                                        className="rea-errorMessage">{this.state.errors.get('amountToPay').message}</div>
                                }
                            </div>
                        </form>
                    </div>
                    <div className="rea-block-12 rea-paymentHeader" ref={this.creditCardInfoSection}>
                        <div>Credit Card Information</div>
                    </div>
                    <div className="rea-block-6 rea-mobile-padding-0">
                        <div className="rea-block-12 rea-padding-0">
                            <form>
                                <div className="rea-block-row rea-inputFieldMargin">
                                    <div className="rea-block-12 rea-mobile-padding-0">
                                        <select
                                            id="cardHolders"
                                            className="dropdown form-control"
                                            onChange={this.cardHolderSelected}
                                            aria-label="Select a Card Holder">
                                            {this.cardHolders}
                                            <option value={-1}>Other</option>
                                        </select>
                                    </div>
                                </div>
                                <div className="rea-block-row rea-inputFieldMargin ">
                                    <div className="rea-block-12 rea-mobile-padding-0">
                                        <input type="text" className="form-control"
                                               placeholder="Name on Card"
                                               id="nameOnCard"
                                               value={this.state.nameOnCard}
                                               name="name"
                                               aria-label="Card Holder Name"
                                               onChange={event => {
                                                   const re = /^[a-zA-Z '-]*$/
                                                   if (re.test(event.target.value)) {
                                                       this.setState({nameOnCard: event.target.value})
                                                       this.handleInputChange(event);
                                                   }
                                               }}
                                               maxLength="70"
                                               onFocus={this.handleInputFocus}
                                               aria-invalid={this.state.errors.get('nameOnCard') !== undefined}>
                                        </input>
                                        <div className="form-inline">
                                            {
                                                this.state.errors.get('nameOnCard') &&
                                                <div
                                                    className="rea-errorMessage">{this.state.errors.get('nameOnCard').message}</div>
                                            }
                                        </div>
                                    </div>
                                </div>
                                <div className="rea-block-row rea-inputFieldMargin ">
                                    <div className="rea-block-12 rea-mobile-padding-0">
                                        {<input type="tel" className="form-control"
                                                name="number"
                                                placeholder="Credit Card Number"
                                                id="creditCardNumber"
                                                aria-label="Credit Card Number"
                                                value={this.state.creditCardNumber}
                                                onChange={event => {
                                                    const re = /^[0-9]+$/
                                                    if (event.target.value === '' || re.test(event.target.value)) {
                                                        this.setState({creditCardNumber: event.target.value})
                                                        this.handleInputChange(event);
                                                    }
                                                }}
                                                onFocus={this.handleInputFocus}
                                                maxLength="16"
                                                aria-invalid={this.state.errors.get('creditCardNumber') !== undefined}
                                                autofocus>
                                        </input>}
                                        <div className="form-inline">
                                            {
                                                this.state.errors.get('creditCardNumber') &&
                                                <div
                                                    className="rea-errorMessage">{this.state.errors.get('creditCardNumber').message}</div>
                                            }
                                        </div>
                                    </div>
                                    <div className="rea-block-6 rea-padding-0"><span
                                        className="rea-ccIcons">
                                                        <i className="fa fa-cc-visa"></i>
                                                        <i className="fa fa-cc-mastercard"></i>
                                                        <i className="fa fa-cc-discover"></i>
                                                        <i className="fa fa-cc-amex"></i>
                                                        </span></div>
                                </div>
                                <div className="rea-block-row">
                                    {this.state.showCreditCardDeclinedErrorMessage &&
                                    <div className="rea-block-12 wth2-errorMessage">
                                        <i className="fa fa-exclamation-circle" aria-hidden="true"></i>
                                        <div className="rea-block-12 wth2-errorMessageHeader">
                                            Credit Card Declined
                                        </div>
                                        <div className="rea-block-12 rea-errorMessage">
                                            Your card has been declined. Please retry with a different card.
                                        </div>
                                    </div>
                                    }
                                </div>
                                <div className="rea-block-row rea-inputFieldMargin">
                                    <div className="rea-block-12 rea-mobile-padding-0">
                                        <div className="rea-block-row">
                                            <div className="rea-block-3 rea-expiryMMField">
                                                <select id="expireMonth" className="dropdown form-control"
                                                        name="expirationDate"
                                                        onChange={event => {
                                                            this.setState({expireMonth: event.target.value})
                                                            this.updateExpiryField(event.target.value, this.state.expireYear);
                                                            this.handleInputChange(event);
                                                        }} onFocus={this.handleInputFocus}
                                                        aria-label="Credit Card Expiration Month"
                                                        aria-invalid={this.state.errors.get('expireMonth') !== undefined || this.state.errors.get('expireDate') !== undefined}>
                                                    <option key="MM" value="MM">MM</option>
                                                    <option key="1" value="1">01</option>
                                                    <option key="2" value="2">02</option>
                                                    <option key="3" value="3">03</option>
                                                    <option key="4" value="4">04</option>
                                                    <option key="5" value="5">05</option>
                                                    <option key="6" value="6">06</option>
                                                    <option key="7" value="7">07</option>
                                                    <option key="8" value="8">08</option>
                                                    <option key="9" value="9">09</option>
                                                    <option key="10" value="10">10</option>
                                                    <option key="11" value="11">11</option>
                                                    <option key="12" value="12">12</option>
                                                </select>
                                                <div className="form-inline">
                                                    {
                                                        this.state.errors.get('expireMonth') &&
                                                        <div
                                                            className="rea-errorMessage">{this.state.errors.get('expireMonth').message}</div>
                                                    }
                                                </div>
                                                <div className="form-inline">
                                                    {
                                                        this.state.errors.get('expireDate') &&
                                                        <div
                                                            className="rea-errorMessage">{this.state.errors.get('expireDate').message}</div>
                                                    }
                                                </div>
                                            </div>
                                            <div className="rea-block-4 rea-expiryYYField">
                                                <select id="expireYear" name="expirationDate"
                                                        className="dropdown form-control"
                                                        onChange={event => {
                                                            this.setState({expireYear: event.target.value})
                                                            this.updateExpiryField(this.state.expireMonth, event.target.value);
                                                        }} onFocus={this.handleInputFocus}
                                                        aria-label="Credit Card Expiration Year"
                                                        aria-invalid={this.state.errors.get('expireYear') !== undefined}>
                                                    {years}
                                                </select>
                                                <div className="form-inline">
                                                    {
                                                        this.state.errors.get('expireYear') &&
                                                        <div
                                                            className="rea-errorMessage">{this.state.errors.get('expireYear').message}</div>
                                                    }
                                                </div>
                                            </div>
                                            {this.state.requireCvv === true &&
                                            <div className="rea-block-4 rea-cvvField">
                                                <input type="tel" className="form-control"
                                                       id="cvc"
                                                       name="cvc"
                                                       value={this.state.cvc}
                                                       aria-label="Credit Card CVV Code"
                                                       placeholder="CVV" onChange={event => {
                                                    const re = /^[0-9]+$/
                                                    if (event.target.value === '' || re.test(event.target.value)) {
                                                        this.setState({cvc: event.target.value})
                                                    }
                                                    //this.handleInputChange(event);
                                                }}
                                                       onFocus={event => {
                                                           this.handleInputFocus(event);
                                                       }}

                                                       onBlur={event => {
                                                           this.handleInputBlur(event);
                                                       }}
                                                       maxLength="4"
                                                       aria-invalid={this.state.errors.get('cvc') !== undefined}></input>
                                                <div className="form-inline">
                                                    {
                                                        this.state.errors.get('cvc') &&
                                                        <div
                                                            className="rea-errorMessage">{this.state.errors.get('cvc').message}</div>
                                                    }
                                                </div>
                                            </div>
                                            }
                                            {this.state.requireCvv === true &&
                                            <div className="rea-block-1 rea-padding-0 rea-cvvPopUpLink">
                                                <a id="creditCardInfoIcon"
                                                   onClick={e=>{e.preventDefault();this.showCreditCardPopup()}} href="# ">
                                                    <i className="fa fa-info-circle"></i>
                                                </a>
                                            </div>
                                            }
                                        </div>
                                    </div>
                                </div>
                            </form>
                        </div>
                    </div>
                    <div className="rea-block-6 rea-mobile-padding-0">
                        <CreditCard cvc={this.state.cvc} expiry={this.state.expiry}
                                    focused={this.state.focused}
                                    name={this.state.nameOnCard} number={this.state.creditCardNumber}
                                    updateCreditCardInfo={this.updateCreditCardInfo}
                                    allowedCreditCardTypes={['amex', 'visa', 'discover', 'mastercard']}></CreditCard>
                    </div>
                    <div className="rea-block-row rea-inputFieldMargin ">
                        <div className="rea-block-12 rea-cc-info-note">
                            <div><span className="rea-bold">Please note:</span> If you are using a
                                debit
                                card or
                                a Visa check card, please call your bank to see if you have a daily
                                transaction
                                limit before continuing to make a payment.
                            </div>
                        </div>
                    </div>
                    <div className="rea-block-12 rea-paymentHeader">
                        <div>Billing Address</div>
                    </div>
                    <div className="rea-block-12 rea-mobile-padding-0 rea-billingAddressFields">
                        <form>
                            <div className="rea-block-row rea-inputFieldMargin">
                                <div className="rea-block-6 rea-mobile-padding-0"><input type="text"
                                                                                         class="form-control"
                                                                                         placeholder="Street Address 1"
                                                                                         aria-label="Street Address 1"
                                                                                         value={this.state.address1}
                                                                                         id="address1"
                                                                                         name="address1"
                                                                                         onChange={event => {
                                                                                             this.setState({address1: event.target.value})
                                                                                         }}
                                                                                         maxLength="30"
                                                                                         aria-invalid={this.state.errors.get('address1') !== undefined}></input>
                                    <div className="form-inline">
                                        {
                                            this.state.errors.get('address1') &&
                                            <div
                                                className="rea-errorMessage">{this.state.errors.get('address1').message}</div>
                                        }
                                    </div>
                                </div>
                                <div className="rea-block-6 rea-mobile-padding-0"><input type="text"
                                                                                         class="form-control"
                                                                                         placeholder="Street Address 2"
                                                                                         aria-label="Street Address 2"
                                                                                         value={this.state.address2}
                                                                                         id="address2"
                                                                                         name="address2"
                                                                                         onChange={event => {
                                                                                             this.setState({address2: event.target.value})
                                                                                         }}
                                                                                         maxLength="30"
                                                                                         aria-invalid={this.state.errors.get('address2') !== undefined}></input>
                                    <div className="form-inline">
                                        {
                                            this.state.errors.get('address2') &&
                                            <div
                                                className="rea-errorMessage">{this.state.errors.get('address2').message}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                            <div className="rea-block-row rea-inputFieldMargin">
                                <div className="rea-block-6 rea-mobile-padding-0"><input type="text"
                                                                                         class="form-control"
                                                                                         placeholder="City"
                                                                                         aria-label="City"
                                                                                         value={this.state.city}
                                                                                         id="city"
                                                                                         name="city"
                                                                                         onChange={event => {
                                                                                             this.setState({city: event.target.value})
                                                                                         }}
                                                                                         maxLength="30"
                                                                                         aria-invalid={this.state.errors.get('city') !== undefined}></input>
                                    <div className="form-inline">
                                        {
                                            this.state.errors.get('city') &&
                                            <div
                                                className="rea-errorMessage">{this.state.errors.get('city').message}</div>
                                        }
                                    </div>
                                </div>
                                <div className="rea-block-3 rea-mobile-padding-0">
                                    <select id="state" aria-label="State" value={this.state.state}
                                            className="dropdown form-control"
                                            placeholder="State"
                                            onChange={event => {
                                                this.setState({state: event.target.value})
                                            }}
                                            aria-invalid={this.state.errors.get('state') !== undefined}>
                                        <option value='null'>State</option>
                                        {this.state.statesList}
                                    </select>
                                    <div className="form-inline">
                                        {
                                            this.state.errors.get('state') &&
                                            <div
                                                className="rea-errorMessage">{this.state.errors.get('state').message}</div>
                                        }
                                    </div>
                                </div>
                                <div className="rea-block-3 rea-mobile-padding-0"><input type="text"
                                                                                         class="form-control"
                                                                                         placeholder="5-digit U.S. Zip Code"
                                                                                         aria-label="Zip Code"
                                                                                         value={this.state.zipCode}
                                                                                         id="zipCode"
                                                                                         name="zipCode"
                                                                                         onChange={event => {
                                                                                             const re = /^[0-9]+$/
                                                                                             if (event.target.value === '' || re.test(event.target.value)) {
                                                                                                 this.setState({zipCode: event.target.value})
                                                                                             }
                                                                                         }}
                                                                                         maxLength="5"
                                                                                         aria-invalid={this.state.errors.get('zipCode') !== undefined}></input>
                                    <div className="form-inline">
                                        {
                                            this.state.errors.get('zipCode') &&
                                            <div
                                                className="rea-errorMessage">{this.state.errors.get('zipCode').message}</div>
                                        }
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                    <div className="rea-block-12 rea-mobile-padding-0">
                        <div className="rea-block-12 rea-termsCondPara rea-mobile-padding-0">
                            <div>
                                By submitting this payment, I understand and accept all associated Terms and Conditions. I accept the restrictions and penalties of the fare(s). I also understand that cancellation fees may apply.
                            </div>
                            <a onClick={e=>{e.preventDefault();this.showAcceptTermsAndConditionsPopup()}}
                               className="rea-textLink" href="# ">View
                                Terms and
                                Conditions</a>
                        </div>
                        <div className="rea-block-12 rea-submitBtnContainer">
                            <button id="makePaymentButton" className="btn wth2-ui-btn rea-submitBtn"
                                    onClick={this.showPaymentConfirmationPopup}>
                                Submit Payment
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    leisureCarePaymentNeeded = () => {
        return this.booking.insuranceTotal > 0 &&
            this.booking.remainingBalanceIncludingInsurance !== this.booking.remainingBalanceExcludingInsurance;
    }

    cancelTermsAndConditions = (event) => {
        this.setState({showTermsAndConditionsPopup: false})
    }

    showAcceptTermsAndConditionsPopup = (event) => {
        this.setState({showTermsAndConditionsPopup: true})
    }

    getRemainingBalanceToPay = (event) => {
        return (this.state.includeInsurance ? this.booking.remainingBalanceIncludingInsurance : this.booking.remainingBalanceExcludingInsurance).toFixed(2);
    }

    getNextAmountToPay = (event) => {
        let pastDueAmount = (this.booking.pastDueAmount && this.booking.nextPaymentDueAmount) ? this.booking.pastDueAmount : 0;
        return (pastDueAmount + (this.state.includeInsurance ? (this.booking.nextPaymentDueAmount + this.booking.remainingBalanceIncludingInsurance - this.booking.remainingBalanceExcludingInsurance) : this.booking.nextPaymentDueAmount)).toFixed(2);
    }

    getAmountToPay = (event) => {
        let amountToPay = 0;
        if (this.state.payRemainingBalance) {
            amountToPay = this.getRemainingBalanceToPay();
        } else {
            if (this.state.payNextPaymentDue) {
                amountToPay = this.getNextAmountToPay();
            } else {
                amountToPay = this.state.otherAmountToPay;
            }
        }
        return amountToPay;
    }

    cancelPayment = (event) => {
        document.getElementById('makePaymentButton').focus();
        this.setState({showConfirmationPopup: false});
    }

    // custom validations

    validateIncludeLeisureCareSelection = () => {
        const value = this.state.includeInsurance;
        let errors = this.state.errors;
        errors.delete('includeLeisureCare');
        let valid = true;
        if (value === null || value === undefined) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("includeLeisureCare").focus();
            }
            errors.set('includeLeisureCare', {
                input: 'includeLeisureCare',
                message: 'Select an option for LeisureCare Travel Insurance'
            });
            valid = false;
        }
        return valid;
    }

    validateNameOnCard = () => {
        const value = this.state.nameOnCard;
        let errors = this.state.errors;
        errors.delete('nameOnCard');
        let valid = true;
        if (value.length < 2 || !/^[a-zA-Z '-]+$/i.test(value) || value.trim().split(' ').length < 2) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("nameOnCard").focus();
            }
            errors.set('nameOnCard', {
                input: 'nameOnCard',
                message: 'Enter valid First and Last Name on Card'
            });
            valid = false;
        }
        this.setState({errors: errors});
        return valid;
    }

    validateCreditCard = () => {
        let errors = this.state.errors;
        errors.delete('creditCardNumber');
        let valid = true;
        if (!this.state.isCreditCardValid || !this.state.isCreditCardAllowed) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("creditCardNumber").focus();
            }
            errors.set('creditCardNumber', {
                input: 'creditCardNumber',
                message: 'Credit card number is not valid or is not an accepted credit card type'
            });
            valid = false;
        }
        this.setState({errors: errors});
        return valid;
    }

    validateAmount = () => {
        let amount = this.getAmountToPay();
        let errors = this.state.errors;
        let valid = true;
        errors.delete('amountToPay');
        if (isNaN(amount) || amount === 0 || amount < this.minimumPaymentDue() || (this.state.includeInsurance === true && amount > this.booking.remainingBalanceIncludingInsurance) || (!this.state.includeInsurance === true && amount > this.booking.remainingBalanceExcludingInsurance)) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("payOtherAmount").focus();
            }
            errors.set('amountToPay', {
                input: 'payOtherAmount',
                message: 'Enter a valid Amount'
            });
            valid = false;
        } else {
        }
        return valid;
    }

    validateCvc = () => {
        if (this.state.requireCvv !== false) {
            const value = this.state.cvc;
            let errors = this.state.errors;
            let valid = true;
            errors.delete('cvc');
            if (this.state.cvcRequiredLength.indexOf(value.length) < 0) {
                if (!this.htmlElementFocused) {
                    this.htmlElementFocused = true;
                    document.getElementById("cvc").focus();
                }
                errors.set('cvc', {
                    input: 'cvc',
                    message: 'Enter valid CVV number'
                });
                valid = false;
            }
            return valid;
        } else {
            return true;
        }
    }

    validateAddress1 = () => {
        const value = this.state.address1.trim();
        let errors = this.state.errors;
        let valid = true;
        errors.delete('address1');
        let regex = /^[ A-Za-z0-9.#'-]*$/;
        if (value.length < 2 || !regex.test(value)) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("address1").focus();
            }
            errors.set('address1', {
                input: 'address1',
                message: 'Enter valid Billing Address1'
            });
            valid = false;
        }
        return valid;
    }

    validateAddress2 = () => {
        const value = this.state.address2.trim();
        let errors = this.state.errors;
        let valid = true;
        errors.delete('address2');
        let regex = /^[ A-Za-z0-9.#'-]*$/;
        if (!regex.test(value)) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("address2").focus();
            }
            errors.set('address2', {
                input: 'address2',
                message: 'Enter valid Billing Address2'
            });
            valid = false;
        }
        return valid;
    }

    validateCity = () => {
        const value = this.state.city.trim();
        let errors = this.state.errors;
        let valid = true;
        errors.delete('city');
        let regex = /^[ A-Za-z0-9.#'-]*$/;
        if (value.length < 2 || !regex.test(value)) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("city").focus();
            }
            errors.set('city', {
                input: 'city',
                message: 'Enter valid City'
            });
            valid = false;
        }
        return valid;
    }

    validateZipCode = () => {
        const value = this.state.zipCode;
        let errors = this.state.errors;
        let valid = true;
        errors.delete('zipCode');
        this.setState({validationOnServerSideIsDone: true});
        let regex = /^[0-9]{5}$/;
        if (value.length < 5 || !regex.test(value)) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("zipCode").focus();
            }
            errors.set('zipCode', {
                input: 'zipCode',
                message: 'Enter valid Zip Code'
            });
            valid = false;
        }
        return valid;
    }

    validateState = () => {
        const value = this.state.state;
        let errors = this.state.errors;
        let valid = true;
        errors.delete('state');
        let regex = /^[A-Za-z]{2}$/;
        if (value === 'null' || !regex.test(value)) {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("state").focus();
            }
            errors.set('state', {
                input: 'state',
                message: 'Select Billing State'
            });
            valid = false;
        }
        return valid;
    }

    validateExpirationDate = () => {
        const month = this.state.expireMonth;
        const year = this.state.expireYear;
        let valid = true;
        let errors = this.state.errors;
        errors.delete('expireMonth');
        errors.delete('expireYear');
        errors.delete('expireDate');

        if (month.toLowerCase() === 'mm') {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("expireMonth").focus();
            }
            errors.set('expireMonth', {
                input: 'expireMonth',
                message: 'Select Expiration Month'
            });
            valid = false;
        }

        if (year.toLowerCase() === 'yyyy') {
            if (!this.htmlElementFocused) {
                this.htmlElementFocused = true;
                document.getElementById("expireYear").focus();
            }
            errors.set('expireYear', {
                input: 'expireYear',
                message: 'Select Expiration Year'
            });
            valid = false;
        }

        if (!isNaN(month) && !isNaN(year)) {
            const currentDate = new Date();
            const monthNumber = Number(month);
            const yearNumber = Number(year);
            if (yearNumber === currentDate.getFullYear() && monthNumber < currentDate.getMonth() + 1) {
                if (!this.htmlElementFocused) {
                    this.htmlElementFocused = true;
                    document.getElementById("expireMonth").focus();
                }
                errors.set('expireDate', {
                    input: 'expireMonth',
                    message: 'Select a valid Expiration Date'
                });
                valid = false;
            }
            return valid;
        }
    }

    // end of custom validations

    formIsValid = () => {
        this.htmlElementFocused = false;
        let includeLeisureCare = !this.leisureCarePaymentNeeded() ? true : this.validateIncludeLeisureCareSelection();
        let amount = this.validateAmount();
        let nameOnCard = this.validateNameOnCard();
        let creditCard = this.validateCreditCard();
        let expirationDate = this.validateExpirationDate();
        let cvc = this.validateCvc();

        let address1 = this.validateAddress1();
        let address2 = this.validateAddress2();
        let state = this.validateState();
        let city = this.validateCity();
        let zipCode = this.validateZipCode();

        return includeLeisureCare && nameOnCard && creditCard && cvc && amount && address1 && address2 && city && zipCode && state && expirationDate && this.state.validationOnServerSideIsDone;
    }

    handleSubmit = (event) => {
        event.preventDefault();
        this.setState({paymentInProcess: true});
        console.log('Saving payment...');
        const hash = this.props.hash;
        const url = '/wthrest/customer-self-service/makePayment.rs';

        const upliftEl = document.getElementById('up-pay-monthly-payment');
		const monthlyPayment = upliftEl ? upliftEl.checked : false;

        // #43925 Javier and Arun approved: send 0000 as cvv when not required to bypass swap validation for now as SWAP cannot be modified now 08/02/2022
        const cvv = this.state.requireCvv ? this.state.cvc : '0000';
        const payload = {
            "bookingNumber": this.booking.bookingId,
            "css_ins": this.state.includeInsurance === true,
            "paymentAmount": this.getAmountToPay(),
            "customerNumber": this.state.nameOnCard.trim(),
            "token": this.state.creditCardNumber.trim(),
            "ccYear": this.state.expireYear.toString(),
            "ccMonth": this.state.expireMonth.toString(),
            "customerAddressNumber": (this.state.address1.trim() + ' ' + this.state.address2.trim()).trim(),
            "cvv": cvv,
            "css_address1": this.state.address1.trim(),
            "css_address2": this.state.address2.trim(),
            "css_city": this.state.city.trim(),
            "css_paymentState": this.state.state.trim(),
            "css_zip": this.state.zipCode.trim(),
            "hash": hash,
            "monthlyPayment" : monthlyPayment
        };
        fetch(url, {
            method: 'POST',
            headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(payload)
        }).then(paymentResponse => {
            this.setState({paymentInProcess: false});
            if (paymentResponse.status !== 200) {
                const errorCode = paymentResponse.headers.get('X-Error-Code');
                const errorMsg = paymentResponse.headers.get('X-Error-Message');
                if (errorCode === 501) {
                    this.creditCardInfoSection.current.scrollIntoView({behavior: "smooth"});
                    this.setState({showCreditCardDeclinedErrorMessage: true})
                    this.setState({showConfirmationPopup: false});
                } else {
                    console.log(errorMsg);
                    this.props.onPaymentError(errorMsg);
                    this.setState({showConfirmationPopup: false})
                }
            } else {
                paymentResponse.json().then(jsonPaymentResponse => {
                    this.props.onPaymentSubmit(jsonPaymentResponse);
                    this.setState({showConfirmationPopup: false});
                });
            }
        }).catch(error => {
            console.log(error);
            this.setState({paymentInProcess: false});
            this.props.onPaymentError(error);
            this.setState({showConfirmationPopup: false})
        });

    }

    showPaymentConfirmationPopup = (event) => {
        //if (this.formIsValid()) {
        // validate zipCode with state...
        let formIsValid = this.formIsValid();
        if (this.state.state !== 'null' && this.state.zipCode !== null && this.state.zipCode !== undefined && this.state.zipCode !== '' && this.validateZipCode()) {
            let url = '/wthrest/customer-self-service/validateStateZipcode.rs';
            let payload = {stateCode: this.state.state, zipCode: this.state.zipCode};
            let errors = this.state.errors;
            errors.delete('zipCode');
            //eslint-disable-next-line
            const validationOnServer = fetch(url, {
                method: 'POST',
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(payload)
            }).then(validationResponse => validationResponse.json()).then(jsonValidationResponse => {
                if (!jsonValidationResponse.validStateZip) {
                    errors.set('zipCode', {
                        input: 'zipCode',
                        message: 'Enter valid Zip Code'
                    });
                    this.setState({errors: errors});
                    //this.paymentInformation.current.scrollIntoView({behavior: "smooth"});
                } else {
                    if (formIsValid) {
                        this.showPaymentPopUp();
                    } else {
                        //this.paymentInformation.current.scrollIntoView({behavior: "smooth"});
                    }
                }
            });
        } else {
            if (formIsValid) {
                this.showPaymentPopUp();
            } else {
                //this.paymentInformation.current.scrollIntoView({behavior: "smooth"});
            }
        }
    }

    showPaymentPopUp = () => {
        let charges = this.state.charges;
        charges.currentAmount = this.getAmountToPay();
        charges.remainingBalanceIncludingInsurance = this.booking.remainingBalanceIncludingInsurance - charges.currentAmount;
        charges.remainingBalanceExcludingInsurance = this.booking.remainingBalanceExcludingInsurance - charges.currentAmount;

        this.setState({charges: charges});

        this.setState({showConfirmationPopup: true})
    }

    closeCreditCardPopup = (event) => {
        document.getElementById('creditCardInfoIcon').focus();
        this.setState({showCreditCardPopup: false});
    }

    showCreditCardPopup = (event) => {
        this.setState({showCreditCardPopup: true});
    }

    minimumPaymentDue = (event) => {
        /*const amountDue = Number(this.booking.totalWithOutInsurance); //this.booking.remainingBalanceIncludingInsurance - this.booking.remainingBalanceExcludingInsurance;*/
        let amountDue = Number(this.booking.remainingBalanceExcludingInsurance);
        let minimum = Number(this.DEFAULT_MIN_AMOUNT_DUE);

        if (this.state.includeInsurance) {
            amountDue = Number(this.booking.remainingBalanceIncludingInsurance);
            const leisureCareAmountDue = (this.booking.remainingBalanceIncludingInsurance - this.booking.remainingBalanceExcludingInsurance).toFixed(2);
            if (leisureCareAmountDue > minimum) {
                minimum = Number(leisureCareAmountDue);
            }
        }

        return amountDue < minimum ? amountDue : minimum;
    }

    cardHolderSelected = (event) => {
        const index = Number(event.target.value);
        this.populateBillingSection(index);
    }

    populateBillingSection = (index) => {
        if (index === -1) {
            this.setState({nameOnCard: ''});
            this.setState({address1: ''});
            this.setState({address2: ''});
            this.setState({city: ''});
            this.setState({state: ''});
            this.setState({zipCode: ''});
        } else {
            const guest = index < this.booking.guests.length ? this.booking.guests[index] : this.booking.bookingEmailContact;
            this.setState({nameOnCard: (guest.firstName && guest.lastName) ? guest.firstName + ' ' + guest.lastName : ''});
            this.setState({address1: guest.address1 ? guest.address1 : ''});
            this.setState({address2: guest.address2 ? guest.address2 : ''});
            this.setState({city: guest.city ? guest.city : ''});
            this.setState({state: guest.state ? guest.state : ''});
            this.setState({zipCode: guest.zipCode ? guest.zipCode : ''});
        }
    }

    openPrintVersion = (event) => {
        const termsAndConditionsMarkup = this.booking.termsAndConditionsMarkup;
        let newWindow = window.open('about:blank');
        if (newWindow) {
            newWindow.document.write(termsAndConditionsMarkup);
        }
    }

    handleInputFocus = (e) => {
        this.setState({focused: e.target.name});
    }

    handleInputBlur = (e) => {
        this.setState({focused: ''});
    }

    handleInputChange = (e) => {
        const {name, value} = e.target;
        this.setState({[name]: value});
    }

    updateCreditCardInfo = (card, validity) => {
        this.setState({isCreditCardValid: validity.valid})
        this.setState({isCreditCardAllowed: validity.allowed})

        if (card !== null) {
            this.setState({cvcRequiredLength: card.cvcLength});
        } else {
            this.setState({cvcRequiredLength: [3]});
        }
    }

    updateExpiryField = (month, year) => {
        if (month.length === 1) {
            month = '0' + month;
        }
        this.setState({expiry: month + '/' + year});
    }

    selectInputValue = (event) => {
        event.target.select();
    }

}

export default PaymentInformation;
